import React from "react";
import "./style.css";

export default function CummulativeBox({ name,name2, value, img, unit }) {
    return (
        <div className="cummulative_box_inv">
            <div className="header_section_c_box">
                <div className="heading_style_1">
                    <h3>
                        {name}
                    </h3>
                    <p>{name2}</p>
                </div>
                <div className="image_section_notate">
                    <img src={img} alt="" srcset="" />
                </div>
               
            </div>
            <div className="value_section">
                <h1>
                    {value}
                </h1>
                <p>{unit}</p>
            </div>

        </div>
    )
}